import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { useNavigate, useLocation } from 'react-router-dom';
import ReviewTable from '../components/ReviewTable';
import SearchInput from '../components/common/SearchInput';
import Pagination from '../components/common/Pagination';
import { Sparkles, ShieldCheck, Headphones } from 'lucide-react';

function ReviewPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const initialPage = parseInt(params.get('page')) || 1;

  const [loading, setLoading] = useState(false);
  const [reviews, setReviews] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [searchKeyword, setSearchKeyword] = useState('');
  const [currentPage, setCurrentPage] = useState(initialPage);
  const [totalPages, setTotalPages] = useState(1);
  const [totalCount, setTotalCount] = useState(0);

  const fetchReviews = useCallback(
    async (page = 1) => {
      setLoading(true);
      try {
        const response = await axios.get(`/reviewApply`, {
          params: {
            page,
            limit: 10,
            search: searchKeyword,
          },
        });
        setReviews(response.data.items);
        setTotalPages(response.data.totalPages);
        setCurrentPage(response.data.currentPage);
        setTotalCount(response.data.totalCount);
      } catch (error) {
        console.error('서버 접속 에러:', error);
      } finally {
        setLoading(false);
      }
    },
    [searchKeyword]
  );

  useEffect(() => {
    fetchReviews(currentPage);
  }, [currentPage, fetchReviews]);

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    navigate(`/reviewApply?page=${newPage}`);
  };

  return (
    <>
      {/* 히어로 */}
      <section className="relative overflow-hidden w-screen left-1/2 -translate-x-1/2 -mt-6 md:-mt-8">
        <div className="absolute inset-0 bg-gradient-to-br from-sky-600/20 via-violet-600/10 to-transparent" />
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_80%_50%_at_50%_-20%,rgba(120,119,198,0.15),transparent)]" />
        <div className="relative max-w-4xl mx-auto px-4 sm:px-6 pt-16 pb-10 sm:pt-20 sm:pb-12 text-center">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 bg-sky-500/10 border border-sky-500/20 rounded-full text-sky-400 text-xs font-medium mb-6">
            <Sparkles size={13} /> Music Review
          </div>
          <h1 className="text-3xl sm:text-4xl font-extrabold text-white mb-3">방송심의</h1>
          <p className="text-slate-400 text-sm sm:text-base">음원심의 신청 및 진행상황을 확인하세요.</p>
          {/* 탭 */}
          <div className="flex items-center justify-center gap-2 mt-6">
            <button
              className="flex items-center gap-1.5 px-4 py-2 rounded-xl text-sm font-medium transition-colors bg-sky-500/20 text-sky-400 border border-sky-500/30">
              <Headphones size={14} />
              음원심의
            </button>
          </div>
        </div>
      </section>

      <div className="max-w-6xl mx-auto px-4 sm:px-6 pb-8">
      <SearchInput
        placeholder="앨범명 또는 아티스트명 검색"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        onSearch={() => {
          setCurrentPage(1);
          setSearchKeyword(searchTerm);
          navigate(`/ReviewPage?page=1`);
        }}
      />

      {loading ? (
        <div className="flex justify-center items-center h-64">
          <div className="animate-spin rounded-full h-10 w-10 border-t-2 border-sky-500 mr-3"></div>
          <div className="text-sm text-slate-500">데이터 불러오는 중...</div>
        </div>
      ) : (
        <>
          <ReviewTable
            data={reviews}
            totalCount={totalCount}
            currentPage={initialPage}
            pageSize={10}
          />

          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
          />

          <div className="w-full flex justify-end items-center mt-6">
            <button
              onClick={() => navigate('/ReviewWritePage')}
              className="inline-flex items-center gap-2 px-6 py-3 rounded-xl text-sm font-semibold bg-gradient-to-r from-sky-500 to-violet-500 hover:from-sky-400 hover:to-violet-400 text-white shadow-lg shadow-sky-500/25 transition-all">
              <ShieldCheck size={16} />
              신규 신청
            </button>
          </div>
        </>
      )}
      </div>
    </>
  );
}

export default ReviewPage;
